import { inject } from "@angular/core";
import type { ResolveFn } from "@angular/router";
import { SessionService } from "@kno2/core/session";
import { SubscriptionPlan, SubscriptionPlansService } from "@kno2/data-access/subscription-plans";

export const planResolver: ResolveFn<SubscriptionPlan> = async (route, state) => {
    const sessionService = inject(SessionService);
    const plansService = inject(SubscriptionPlansService);

    const organizationId = sessionService.profileData().organizationId;
    return await plansService.getSubscriptionPlanAsync(organizationId);
};
